export const getMethods = ({ fn, auctionId, status, memberType, debugging }) => {
  return {
    name: 'member',
    fn,
    args: [
      'auctionID',
      'pageNumber',
      'pageSize',
      'searchText',
      'sortColumn',
      'sortDirection',
      'status',
      'memberType',
      'debugging',
    ],
    dataToMerge: {
      auctionID: auctionId,
      status,
      memberType,
      debugging,
    },
  };
}
